<template>
  <el-dialog
    title="查看返修原因"
    :visible="visible"
    width="600px"
    @update:visible="$emit('update:visible', $event)"
    @close="onClose"
  >
    <div v-if="loading" style="text-align: center; padding: 20px">
      <i class="el-icon-loading"></i> 加载中...
    </div>
    <template v-else-if="data">
      <el-form label-width="90px">
        <el-form-item label="返修原因：">
          <span>{{ data.reviewReason || '暂无' }}</span>
        </el-form-item>
        <el-form-item label="返修附件：">
          <div
            v-if="data.reviewAttachList && data.reviewAttachList.length"
            style="display: flex; flex-wrap: wrap; gap: 10px"
          >
            <SlImage v-for="(url, idx) in data.reviewAttachList" :key="idx" :src="url" size="8rem" />
          </div>
          <span v-else style="color: #999">暂无附件</span>
        </el-form-item>
      </el-form>
    </template>
  </el-dialog>
</template>

<script>
import SettlementApi from '@api/settlement'

export default {
  name: 'RepairReasonDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    supplementaryDeductionId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      loading: false,
      data: null
    }
  },
  watch: {
    visible (val) {
      if (val && this.supplementaryDeductionId) {
        this.fetchData()
      }
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.data = null
      SettlementApi.getSupplementaryDeductionQaInfo(this.supplementaryDeductionId).then(res => {
        if (res.success) {
          this.data = res.data || {}
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onClose () {
      this.data = null
      this.$emit('update:visible', false)
    }
  }
}
</script>
